<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja deletar este saque?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
  data () {
    return {
      error: null,
      loading: true,
      formErrors: []
    }
  },
  components: {
    BaseDelete: BaseDelete
  },
  props: {
    entry: Object,
    modelNameSingular: String,
  },
  methods: {
    destroyServerEntry: function(withdraw) {
      this.loading = true;
        this.$apollo
          .mutate({
            mutation: DESTROY_WITHDRAW_MUTATION,
            variables: {
              id: withdraw.id,
            }
          })
          .then(response => {
            var errors = response.data.destroyWithdraw.errors
            if (errors.length){
              this.formErrors = errors
            } else {
              this.$emit("entry-destroyed");
              this.$refs.baseDelete.closeDialog();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
    },
    destroyEntry: function() {
      this.destroyServerEntry(this.entry);
    },
  }
}
const DESTROY_WITHDRAW_MUTATION = gql `
  mutation($id: ID!) {
    destroyWithdraw(id: $id) {
      withdraw {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>